import {
  Package, FolderTree 
} from 'lucide-react';

export const TABS = [
  {
    id: 'items',
    label: 'Items',
    href: '/catalog/items',
    icon: Package 
  },
  {
    id: 'categories',
    label: 'Categories',
    href: '/catalog/categories',
    icon: FolderTree 
  },
];

export const CATEGORIES = [
  'All',
  'Seafood',
  'Meat',
  'Dairy',
  'Produce',
  'Oils & Fats',
  'Grains',
  'Canned Goods',
  'Beverages',
];

export const UNIT_OPTIONS = [
  {
    value: 'kg',
    label: 'Kilogram (kg)' 
  },
  {
    value: 'lb',
    label: 'Pound (lb)' 
  },
  {
    value: 'each',
    label: 'Each' 
  },
  {
    value: 'case',
    label: 'Case' 
  },
  {
    value: 'liter',
    label: 'Liter' 
  },
  {
    value: 'gallon',
    label: 'Gallon' 
  },
];
